"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { useId, useState, useEffect } from "react";
import { Box } from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import { StyledSkeleton } from "./styles.js";
import { SkeletonVariant } from "../enums.js";
const CustomSingleSkeleton = ({
  height,
  sx,
  variant,
  width,
  hiddenText,
  ...props
}) => {
  const computedSx = [
    { bgcolor: "#C7C7C7" },
    ...Array.isArray(sx) ? sx : [sx]
  ];
  const computedVariant = variant !== SkeletonVariant.Circular ? SkeletonVariant.Rectangular : variant;
  const hiddenTextId = useId();
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);
  return /* @__PURE__ */ jsxs(Box, { className: "skeleton-wrapper", sx: { width }, children: [
    hiddenText && isClient && /* @__PURE__ */ jsx("span", { id: hiddenTextId, style: visuallyHidden, children: hiddenText }),
    /* @__PURE__ */ jsx(
      StyledSkeleton,
      {
        animation: "wave",
        sx: computedSx,
        height,
        variant: computedVariant,
        width,
        "aria-busy": true,
        "aria-hidden": true,
        "aria-labelledby": hiddenText && isClient ? hiddenTextId : void 0,
        ...props
      }
    )
  ] });
};
export {
  CustomSingleSkeleton
};
